@if (_currentData.resouceDef) {
  <div class="main-content-container">
    <div class="container-title">
      @if (_currentData.currentAction == 'LIST') {
        <h3 class="mb-0">
          {{baseService._currentTitle}}
        </h3>
      }
      @if (_currentData.currentAction != 'LIST') {
        <h3 class="mb-0">
          <div class="d-flex align-items-center">
            <div class="pl-2 pr-2">
              <a class="d-inline-flex" href="javascript:void(0)" (click)="listResource()">
                <img src="assets/images/grid-back.png" />
              </a>
            </div>
            <div class="">
              {{baseService._currentTitle}}
            </div>
          </div>
        </h3>
      }
    </div>
    <div class="main-container-body">
      @if (_currentData.currentData) {
        <dhs-form [action]="_currentData.currentAction" [fieldGroup]="_currentData.currentFormFields" [config]="_currentData.config" [data]="_currentData.currentData" [customButton]="_currentData.customButton" (saveFinished)="onSaveFinished($event)">  </dhs-form>
      }
    </div>
  </div>
}